import { performPutRequest } from '@atlassian/jira-fetch';

export const PROPERTY_KEY = 'jira.user.parent-field.changeboarding';

const getUserUrl = (accountId: string) =>
	`/rest/api/3/user/properties/${PROPERTY_KEY}?accountId=${accountId}`;

export const setUserProperty = async (accountId: string): Promise<void> => {
	const url = getUserUrl(accountId);

	const response: Response = await performPutRequest(url, {
		body: JSON.stringify(true),
	});

	if (response && !response.ok) {
		throw Error('Failed to dismiss changeboarding spotlight for Parent field');
	}
};

export const getUserProperty = async (accountId: string): Promise<boolean> => {
	const url = getUserUrl(accountId);

	const response: Response = await fetch(url);

	// ok is true only when status code is 2xx.
	if (response.ok) {
		const responseObj = await response.json();
		return responseObj.value;
	}

	const { status } = response;

	// 404: API deliberately returns 404 if user property is not found, which implies the user has not dismissed the spotlight.
	if (status === 404) {
		return false;
	}

	// returning the default value (dismissed) regardless of endpoint errors.
	return true;
};
